import React from "react";
import Highcharts from "highcharts";
import PieChart from "highcharts-react-official";

function DonutChart(props) {
	const optionsPie = {
		chart: {
			renderTo: "container",
			type: "pie",
			plotBackground: "transparent",
			margin: [0, 0, 0, 0],
			spacingTop: 0,
			spacingBottom: 0,
			spacingLeft: 0,
			spacingRight: 0,
			marginBottom: 5,
		},

		title: {
			verticalAlign: "middle",
			x: -4,
			y: 26,
			floating: true,
			text: props.data.count,
			style: {
				fontFamily: "Poppins",
				fontSize: "23px",
				color: "#4D4F5C",
				opacity: 1,
			},
		},

		subtitle: {
			text: props.data.leaveType,
			verticalAlign: "bottom",
			y: 16,
			style: {
				fontFamily: "Poppins",
				fontWeight: "500",
				fontSize: "19px",
				color: "#4D4F5C",
				opacity: 1,
			},
		},
		credits: {
			enabled: false,
		},
		plotOptions: {
			pie: {
				size: "100%",
				allowPointSelect: true,
				cursor: "pointer",
				shadow: false,
				borderColor: "none",
				dataLabels: {
					enabled: false,
				},
				states: {
					hover: {
						enabled: false, //disable hover color
					},
				},
			},
		},
		tooltip: {
			formatter: function () {
				if (this.colorIndex === 0)
					return `<b>Leaves Availed: </b> ${this.y}`;
				return `<b>Remaining Leaves: </b> ${this.y}`;
			},
			style: {
				fontSize: 16,
			},
		},
		responsive: {
			rules: [
				{
					condition: {
						maxWidth: 500,
					},
					chartOptions: {
						chart: {
							renderTo: "container",
							type: "pie",
							plotBackground: "transparent",
							marginRight: 10,
							margin: [0, 0, 0, 0],
							spacingTop: 0,
							spacingBottom: 0,
							spacingLeft: 0,
							spacingRight: 0,
						},

						plotOptions: {
							pie: {
								allowPointSelect: true,
								size: 10,
								cursor: "pointer",
								shadow: false,
								borderColor: "none",
							},
						},
					},
				},
			],
		},
		series: [
			{
				shadow: false,
				borderWidth: 1,
				borderShadow: false,
				allowPointSelect: false,
				size: "100%",
				innerSize: "60%",
				dataLabels: {
					distance: -17,
					enabled: true,
					marker: {
						fillColor: "black",
					},
					style: {
						fontFamily: "Poppins",
						fontWeight: "bold",
						fontSize: "13px",
						color: "white",
						stroke: "none",
						fill: "none",
						opacity: 1,
					},
				},
				data: props.data.data,
			},
		],
	};

	return (
		<div className="col col-lg-2 col-sm-4 col-md-4 col-xs-2 p-0 leavesQuotaPie">
			<PieChart highcharts={Highcharts} options={optionsPie} />
		</div>
	);
}

export default DonutChart;
